import PropTypes from 'prop-types';
import React from 'react';

import { CommonIcons } from 'common-src/assets/Icons';
import { Tooltip } from 'common-src/components/base';

import styles from './ModuleTitle.module.scss';

const ModuleTitle = ({ title, tooltipMessage }) => (
  <div className={['flex-row', 'vertically-centered', 'gap-5', 'm-b-20'].join(' ')}>
    <p className={[styles.title, 'font-w-600', 'font-s-16'].join(' ')}>{title}</p>
    {tooltipMessage && (
      <Tooltip title={tooltipMessage}>
        <img src={CommonIcons.tooltipIcon} alt="tooltip-icon" className={styles.icon} />
      </Tooltip>
    )}
  </div>
);

ModuleTitle.propTypes = {
  title: PropTypes.string,
  tooltipMessage: PropTypes.string,
};

export default ModuleTitle;
